<template>
  <div class="modal">
    <div class="modal-content">
      <button @click="close" class="modal-close is-large" aria-label="close"></button>
      <div class="digital-vos-scroll">
          <div class="vs-form">
            <div class="vs-section">
              <div class="columns">
                <div class='column is-10 is-offset-1'>
                  <div>
                    <div class='column is-6 is-offset-3 has-text-centered'>
                      <h5 class="subtitle is-5">Verification of Service (VOS) Form</h5>
                    </div>
                  </div>
                  <VosFields 
                    :digitalForm="digitalForm" 
                    @update="update" 
                    @setVariable="setVariable" />
                  <div style="margin-bottom: 25px;">
                    <ul class="center-button">
                      <li>
                        <span style="width: 75px;" v-on:click="save" class='button is-small is-link'
                          v-bind:class="{ 'is-loading': saveLoader }" :disabled="!canSave">Submit</span>
                      </li>
                    </ul>
                    <div v-if="timeNotAllowed" class="signature-support" style="padding: 10px;">
                      <span class="is-danger">
                        Sorry, you cannot submit this VOS yet because the job date and time have yet
                        to start.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import VosFields from "@/reusable_components/VosFieldsComponent";

export default {
  components: {
    VosFields
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters("requestVos", {
      selectedFile: "getSelectedFile",
      digitalForm: "getdigitalFormData",
      canSave: "getcanSave",
      saveLoader: "getsaveLoader"
    }),

    ...mapState("requestVos", {
      timeNotAllowed: state => state.timeNotAllowed
    })
  },
  methods: {
    update(key, value) {
      // dispatch action to update vuex
      VueStore.dispatch("requestVos/updateSelectedData", {
        key: key,
        value: value
      });
    },
    setVariable(key, value) {
      VueStore.dispatch("requestVos/setVariable", {
        key: key,
        value: value
      });
    },
    close() {
      VueStore.dispatch("notify/setShowMessage", {
        key: "viewDigitalVosModal",
        bool: false
      });
    },
    save() {
      if (this.canSave) {
        VueStore.dispatch("requestVos/saveDigital");
      }
    },
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-content {
  padding: 15px;
  top: 60px;
  width: 1000px;
  height: 800px;
  overflow: auto;
  background-clip: border-box !important;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .iframe {
    zoom: 1;
  }
}

.modal-close.is-large {
  height: 42px;
  max-height: 42px;
  max-width: 42px;
  min-height: 42px;
  min-width: 42px;
  width: 42px;
}

.modal-close {
  z-index: 9999;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: rgb(10 10 10 / 52%);
  border: none;
  border-radius: 290486px;
  cursor: pointer;
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 0;
  height: 20px;
  max-height: 20px;
  max-width: 20px;
  min-height: 20px;
  min-width: 20px;
  outline: none;
  vertical-align: top;
  width: 20px;
  height: 40px;
  right: 5px;
  top: 5px;
  width: 40px;
  position: absolute;
}

@media screen and (min-width: 769px) {

  .modal-content {
    margin: 0 auto;
    width: 950px !important;
    overflow: hidden;
  }
}

/* Scroll container that was previously an inline 925px-wide style. */
.digital-vos-scroll {
  position: relative;
  overflow: hidden;
  width: 925px;
  height: calc(100% - 1px);
  overflow-y: auto;
}

/* Mobile/tablet: fill the viewport and scroll inside the modal. The
   1024px breakpoint matches the compliance section's mobile layout. */
@media screen and (max-width: 1024px) {
  .modal-content {
    width: 100vw !important;
    max-width: 100vw;
    height: 100vh;
    top: 0;
    padding: 10px;
  }

  .digital-vos-scroll {
    width: 100%;
  }
}

.vs-form {
  min-width: 400px !important;
  background: #fff !important;
}

.subtitle {
  font-weight: bold;
  font-size: 18px !important;
  margin-bottom: 5px !important;
}

/** */
span.is-danger {
  color: red;
}

.padded-bottom-border {
  padding-bottom: 10px !important;
}

.gray-bg label,
.cancelled-bg label {
  margin-top: 5px !important;
}
</style>
